export default class FilterCollection {
    constructor() {
        this.form = $('.filters form')
        this.bind_events()
    }

    bind_events() {
        const self = this
        let searchTimer = null

        this.form.find('select').on('change', function() {
            self.perform_search(self.form)
        })

        this.form.find('input').on('change keyup', function() {
            clearTimeout(searchTimer)

            searchTimer = setTimeout(function () {
                self.perform_search(self.form)
            }, 400)
        })

        self.bind_pagination()
    }

    bind_pagination() {
        const self = this

        $('.pagination-js .pagination a').on('click', function(event) {
            event.preventDefault()

            const queryParams = event.target.getAttribute('href').split('?')[1]

            if (queryParams) {
                const params = new URLSearchParams('?' + queryParams)

                self.perform_search(self.form, params.get('page'))
            }
        })
    }

    perform_search(form, page = 1) {
        const self = this
        const url = form.data('updateUrl') + '?page=' + page

        self.update_data(form, url)
    }

    set_page(page) {
        this.form.find('input[name=page]').val(page)
    }

    update_data(form, url) {
        $.ajax({
            type: 'POST',
            url: url,
            data: form.serialize(),
            success: (response) => {
                $('#filterable-container').html(response)
                this.bind_pagination()
            }
        })
    }
}
